import moment from "moment";

/**
 * Converts ISO date string to MMM DD, YYYY format
 * @param isoDateString - Date string in ISO format (e.g., "2025-10-08T00:00:00Z")
 * @returns Formatted date string in MMM DD, YYYY format (e.g., "Oct 08, 2025")
 */
export const formatDateToMMDDYYYY = (isoDateString: string): string => {
    if (!isoDateString) {
        return "";
    }

    return moment(isoDateString).format("MMM DD, YYYY");
};

/**
 * Converts ETA ISO date string to readable time difference from now
 * @param etaDateString - ETA date string in ISO format (e.g., "2025-11-21T00:00:00Z")
 * @returns Formatted time difference string (e.g., "5 hours", "3 days", "2 weeks")
 */
export const formatEtaToReadableUnit = (etaDateString: string): string => {
    if (!etaDateString) {
        return "N/A";
    }

    const now = moment();
    const etaDate = moment(etaDateString);

    // If the date is in the past, show as overdue
    if (etaDate.isBefore(now)) {
        const diffDuration = moment.duration(now.diff(etaDate));
        const days = Math.floor(diffDuration.asDays());
        const hours = Math.floor(diffDuration.asHours());

        if (hours < 24) {
            return hours === 1 ? "1 hour overdue" : `${hours} hours overdue`;
        } else if (days === 1) {
            return "1 day overdue";
        } else if (days < 7) {
            return `${days} days overdue`;
        } else {
            const weeks = Math.floor(days / 7);
            return weeks === 1 ? "1 week overdue" : `${weeks} weeks overdue`;
        }
    }

    // Calculate time difference for future dates
    const diffDuration = moment.duration(etaDate.diff(now));
    const totalHours = Math.floor(diffDuration.asHours());
    const totalDays = Math.floor(diffDuration.asDays());
    const totalWeeks = Math.floor(diffDuration.asWeeks());
    const totalMonths = Math.floor(diffDuration.asMonths());

    if (totalHours < 24) {
        return totalHours === 1 ? "1 hour" : `${totalHours} hours`;
    } else if (totalDays < 7) {
        return totalDays === 1 ? "1 day" : `${totalDays} days`;
    } else if (totalDays < 30) {
        return totalWeeks === 1 ? "1 week" : `${totalWeeks} weeks`;
    } else {
        return totalMonths === 1 ? "1 month" : `${totalMonths} months`;
    }
};/**
 
* Converts ISO date string to readable format with time
 * @param isoDateString - Date string in ISO format (e.g., "2025-10-31T07:22:22")
 * @returns Formatted date string (e.g., "October 31, 2025 at 7:22 AM")
 */
export const formatDateWithTimeValue = (isoDateString: string): string => {
    if (!isoDateString) {
        return "";
    }

    return moment(isoDateString).format("MMMM D, YYYY [at] h:mm A");
};

 const formattedStartDate = (startDate: string) => {
        if (!startDate) return "";
        // Set to start of day (00:00:00) for start date
        return moment(startDate).startOf("day").format("YYYY-MM-DDTHH:mm:ss");
    };

const formattedEndDate = (endDate: string) => {
        if (!endDate) return "";
        // Set to end of day (23:59:59) for end date
        return moment(endDate).endOf("day").format("YYYY-MM-DDTHH:mm:ss");
};